import { Matrix } from '@livecontrol/scheduler/components';
import type { Account } from '@livecontrol/scheduler/model';
import type { FormikContextType } from 'formik';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import { Form } from '../../../../components';
import { Counter } from './counter';
import type { Values } from './form';

import G = Matrix.Grid;

const Row = styled(Matrix.Grid.Row)`
  position: relative;

  .users {
    position: sticky;
    left: 0;
    z-index: 2;
  }

  button {
    visibility: hidden;
    display: flex !important;
  }

  &:hover {
    .column {
      border-color: #2e5bff !important;
    }

    button {
      visibility: visible !important;
      display: flex !important;
    }
  }
`;

const CellNoBorder = styled(Matrix.Grid.Row.Cell)`
  border: 0px solid transparent;
  justify-content: center;
  padding: 14px 0px;

  &.transparent {
    background-color: transparent !important;
  }

  &.boder-bottom {
    border-bottom: 1px solid #e4e8f0 !important;
  }

  &:last-child {
    border-right: 0px solid transparent !important;
    padding: 5px 0px !important;
  }

  &:first-child {
    border-left: 0px solid transparent !important;
    position: sticky;
    left: 0;
  }
`;

const Cell = styled(Matrix.Grid.Row.Cell)`
  border-color: #d5daea;
  justify-content: center;
  padding: 14px 0px;

  &.height {
    height: 90px;
  }

  &:first-child {
    border-top-left-radius: var(--spacer-4px);
    border-bottom-left-radius: var(--spacer-4px);
  }
  &:last-child {
    border-top-right-radius: var(--spacer-4px);
    border-bottom-right-radius: var(--spacer-4px);
    padding: 14px 0px;
  }
`;

interface Props {
  subuser: Account.SubUser;
  roleContact: number;
  formik: FormikContextType<Values>;
}

export const RowUser = ({  subuser, roleContact, formik }: Props): ReactElement => (
    <>
      <G.Row>
        <CellNoBorder className='column height-10px' />
        <CellNoBorder className='column height-10px' />
      </G.Row>
      <Row>
        <Cell className='column users justify-content-start'>
          <div className='d-flex flex-column pr-4px'>
            <div className='text-dark font-weight-bold font-size-12px text-capitalize'>
              {subuser.firstName} {subuser.lastName}
            </div>
          </div>
        </Cell>
        <Cell key={`${subuser.id}`} className='column'>
        {roleContact === 5 ? (
                <Counter formik={formik} formName={`${subuser.id}`} />
              ) : (
                <Form.Group
                  name={`${subuser.id}`}
                  label=''
                  className='mb-0'
                  controlProps={{
                    type: 'checkbox'
                  }}
                />
              )}

        </Cell>
      </Row>
    </>
  );
